import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { FanImageVue } from '@/common/primary/fairplayer-image/fan-image';
import { MemberUi } from '@/fairplayer/primary/members-page/Member.ui';

export default defineComponent({
  name: 'MemberCard',

  components: {
    FanImageVue,
  },

  props: {
    member: {
      type: Object as PropType<MemberUi>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
